import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content" };
import BrgPagination from '@/components/BrgPagination.vue';
import { tableHeader } from '@/constants/baromoneyTransferSetting/baromoneytransfersettingTableHeader';
import { pStore } from '@/pinia';
import { storeToRefs } from 'pinia';
import SubController from './SubController.vue';
import HubListTable from './Table.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const pBaromoneyTransferSetting = pStore.piniaBaromoneyTransferSetting;
        const { itemList, filterOption, paginationData, } = storeToRefs(pBaromoneyTransferSetting);
        const getTableHeader = () => tableHeader;
        /**
         * 페이지네이션 클릭 핸들러
         */
        const handleUpdateModelValue = (value) => {
            filterOption.value.pageNumber = value;
            pBaromoneyTransferSetting.getItemList();
        };
        return (_ctx, _cache) => {
            const _component_v_data_table_server = _resolveComponent("v-data-table-server");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(SubController),
                _createElementVNode("div", null, [
                    _createVNode(_component_v_data_table_server, {
                        hover: "",
                        "hide-default-footer": "",
                        density: "comfortable",
                        class: "brg-table",
                        headers: getTableHeader(),
                        items: _unref(itemList),
                        "items-per-page": 1,
                        "items-length": -1
                    }, {
                        [`item`]: _withCtx(({ item }) => [
                            _createVNode(HubListTable, {
                                item: item
                            }, null, 8 /* PROPS */, ["item"])
                        ]),
                        _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["headers", "items"]),
                    _createVNode(BrgPagination, {
                        "model-value": _unref(filterOption).pageNumber,
                        "onUpdate:modelValue": handleUpdateModelValue,
                        length: _unref(paginationData).pages
                    }, null, 8 /* PROPS */, ["model-value", "length"])
                ])
            ]));
        };
    }
});
